import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import redirects from "./redirects.json";
import HomePage from "../pages/home/HomePage";
import AppPlatformPage from "../pages/product/AppPlatformPage";
import SpatialAcceleratorPage from "../pages/product/SpatialAcceleratorPage";
import PrivacyPage from "../pages/legal/PrivacyPage";
import TermsPage from "../pages/legal/TermsPage";
import CookiePolicyPage from "../pages/legal/CookiePolicyPage";
import RefundPolicyPage from "../pages/legal/RefundPolicyPage";
import SecurityPage from "../pages/legal/SecurityPage";
import AboutPage from "../pages/about/AboutPage";
import CareersPage from "../pages/about/CareersPage";
import SupportPage from "../pages/about/SupportPage";
import TeamMemberPage from "../pages/about/TeamMemberPage";
import NewsPage from "../pages/news/NewsPage";
import NewsroomPage from "../pages/news/NewsroomPage";
import NewsArticlePage from "../pages/news/NewsArticlePage";
import DashboardPage from "../pages/developers/DashboardPage";
import ProfilePage from "../pages/developers/ProfilePage";
import SignUpPage from "../pages/auth/SignUpPage";
import LoginPage from "../pages/auth/LoginPage";
import AuthActionPage from "../pages/auth/AuthActionPage";

const routes = [
  ["/", <HomePage />],
  ["/software", <AppPlatformPage />],
  ["/ax", <SpatialAcceleratorPage />],
  ["/privacy", <PrivacyPage />],
  ["/terms", <TermsPage />],
  ["/cookie", <CookiePolicyPage />],
  ["/refund-policy", <RefundPolicyPage />],
  ["/security", <SecurityPage />],
  ["/company", <AboutPage />],
  ["/careers", <CareersPage />],
  ["/research", <NewsPage />],
  ["/research/:slug", <NewsArticlePage />],
  ["/company/newsroom", <NewsroomPage />],
  ["/news/:slug", <NewsArticlePage />],
  ["/support", <SupportPage />],
  ["/signup", <SignUpPage />],
  ["/login", <LoginPage />],
  ["/dashboard", <DashboardPage />],
  ["/profile", <ProfilePage />],
  ["/team/:slug", <TeamMemberPage />],
  ["/auth/action", <AuthActionPage />],
];

function CanonicalRedirect({ to }) {
  const { search, hash } = useLocation();
  return <Navigate to={to + search + hash} replace />;
}

export default function AppRoutes() {
  return (
    <Routes>
      {Object.entries(redirects).map(([from, to]) => (
        <Route key={from} path={from} element={<CanonicalRedirect to={to} />} />
      ))}
      {routes.map(([path, element]) => (
        <Route key={path} path={path} element={element} />
      ))}
    </Routes>
  );
}
